import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { DeniedPartyRequestData, DeniedPartyResponse, DeniedPartyResponseV2, PartyInfo } from './../shared/models/denied-party.interface';
import { retry, map, concatMap, catchError, tap } from 'rxjs/operators';
import { ApiEndpoints as API } from './../../config/api-endpoints';
import { environment as ENV } from './../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { TranslateService } from '@ngx-translate/core';
import { Permissions } from '../shared/models/permissions';
import { UserPermission } from '../shared/models/user-permission';
import { ScriptService } from './script.service';

enum USER_ROLES {
  ADMINISTRATOR = "1",
  ADJUSTER = "2",
  GUESTUSER = "3",
  HPGUESTUSRER = "4",
  SHOPIFYUSER = "5",
  TUPSSUSER = "6",
  DDUSER = "7",
  DDCGUSER = "8",
  BUNDLEDCLAIMUSER = "9"
}

enum ONL_USER_ROLES {
  ADMINISTRATOR = 'administrator',
  ACCOUNT_MANAGER = 'account manager',
  CLAIMS_MANAGER = 'claims manager',
  CLAIMS_FILER = 'claims filer',
  CLAIMS_VIEWER = 'claims viewer',
  BILLING_MANAGER = 'billing manager',
  VIEWER = 'viewer'
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  get userInfo () { return JSON.parse(sessionStorage.getItem('userDetails')); };
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  private locale = new BehaviorSubject<string>('en');
  private _isHVCMFlow: boolean;
  private permissions: Permissions[] = [];
  private userPermissions: UserPermission = new UserPermission();

  constructor(
    private loginService: LoginService,
    private http: HttpClient,
    private router: Router,
    private translateService: TranslateService,
    private scriptService: ScriptService
  ) {

  }

  public setUserPermissions(permission: any) {
    this.permissions.splice(0, this.permissions.length);
    permission.map((value) => {
      if (!this.permissions.find(x => x.permissionName === value)) {
        var permission = new Permissions();
        permission.permissionName = value;
        this.permissions.push(permission);
      }
    });
    sessionStorage.setItem('permissions', JSON.stringify(this.permissions));
  }


  public getUserPermissions(): UserPermission {
    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));

    if (!this.permissions) {  //Zero permissions - user most likely not logged in yet, or something very wrong with their account
      return null;
    }

    if ((this.permissions?.length > 0) && (this.isUsaUser)) {
      this.userPermissions.isAnalytics = this.permissions.find(x => x.permissionName === 'Analytics') ? true : false;
      this.userPermissions.isBillingView = this.permissions.find(x => x.permissionName === 'BillingView') ? true : false;
      this.userPermissions.isBillingPayments = this.permissions.find(x => x.permissionName === 'BillingPayments') ? true : false;
      this.userPermissions.isPolicyView = this.permissions.find(x => x.permissionName === 'PolicyView') ? true : false;
      this.userPermissions.isPolicyUpdate = this.permissions.find(x => x.permissionName === 'PolicyUpdate') ? true : false;
      this.userPermissions.isClaimView = this.permissions.find(x => x.permissionName === 'ClaimView') ? true : false;
      this.userPermissions.isFileClaim = this.permissions.find(x => x.permissionName === 'ClaimFile') ? true : false;
      this.userPermissions.isClaimPayee = this.permissions.find(x => x.permissionName === 'ClaimPayee') ? true : false;
      this.userPermissions.isHVCM = this.permissions.find(x => x.permissionName === 'HVCM') ? true : false;
      this.userPermissions.isManagePaymentMethods = this.permissions.find(x => x.permissionName === 'ManagePaymentMethods') ? true : false;
      this.userPermissions.isSmartUpload = this.permissions.find(x => x.permissionName === 'SmartUpload') ? true : false;
      this.userPermissions.isUserManagement = this.permissions.find(x => x.permissionName === 'UserManagement') ? true : false;
      this.userPermissions.isVerificationCode = this.permissions.find(x => x.permissionName === 'VerificationCode') ? true : false;
    } else {
      this.userPermissions.isAnalytics = this.permissions.find(x => x.permissionName === 'Analytics') ? true : false;
      this.userPermissions.isBillingView = this.permissions.find(x => x.permissionName === 'BillingView') ? true : false;
      this.userPermissions.isBillingPayments = this.permissions.find(x => x.permissionName === 'BillingPayments') ? true : false;
      this.userPermissions.isPolicyView = this.permissions.find(x => x.permissionName === 'PolicyView') ? true : false;
      this.userPermissions.isPolicyUpdate = this.permissions.find(x => x.permissionName === 'PolicyUpdate') ? true : false;
      this.userPermissions.isClaimView = this.permissions.find(x => x.permissionName === 'ClaimView') ? true : false;
      this.userPermissions.isFileClaim = this.permissions.find(x => x.permissionName === 'ClaimFile') ? true : false;
      this.userPermissions.isClaimPayee = this.permissions.find(x => x.permissionName === 'ClaimPayee') ? true : false;
      this.userPermissions.isHVCM = this.permissions.find(x => x.permissionName === 'HVCM') ? true : false;
      this.userPermissions.isManagePaymentMethods = this.permissions.find(x => x.permissionName === 'ManagePaymentMethods') ? true : false;
      this.userPermissions.isSmartUpload = this.permissions.find(x => x.permissionName === 'SmartUpload') ? true : false;
      this.userPermissions.isUserManagement = this.permissions.find(x => x.permissionName === 'UserManagement') ? false : false;
      this.userPermissions.isVerificationCode = this.permissions.find(x => x.permissionName === 'VerificationCode') ? true : false;
    }
    return this.userPermissions;
  }

  getUserInfo() {
     return this.userInfo;
  }

  setUserInfo(userInfo: any) {
    sessionStorage.setItem('userDetails', JSON.stringify(userInfo));
    // this.userInfo = userInfo;
  }

  updateUserInfo(userInfo: any) {
    let userDetails = {
      ...JSON.parse(sessionStorage.getItem('userDetails')),
      ...userInfo
    }
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
    // this.userInfo = userDetails;
  }

  isParentPolicy() {
    let policyinfo = JSON.parse(sessionStorage.getItem('policyDetails'));
    if (policyinfo && policyinfo.isParentPolicy) {
      return true;
    } else {
      return false;
    }
  }

  isEAUserorNonEA() { // is Enterprise Affiliate User or Non Enterprise Affiliate
    let policyinfo = JSON.parse(sessionStorage.getItem('policyDetails'));
    if ((policyinfo) && (policyinfo.isParentPolicy || policyinfo.isChildPolicy)) {
      return true;
    } else {
      return false;
    }
  }


  isGuestUser() {
    let isValidGuestUser = JSON.parse(sessionStorage.getItem('isValidGuestUser'));
    if (this.userInfo) {
      return this.getUserInfo()?.userRoleID === USER_ROLES.GUESTUSER;
    }
    else if (isValidGuestUser != 'T') {
      return false;
    }
    else {
      return true
    }
  }

  isGuestClaim() {
   return this.getUserInfo()?.userRoleID === USER_ROLES.GUESTUSER || this.getUserInfo()?.userRoleID === USER_ROLES.HPGUESTUSRER;
  }

  isShopifyUser() {
    return this.getUserInfo()?.userRoleID === USER_ROLES.SHOPIFYUSER;
  }

  isBundledClaimUser() {
    return this.getUserInfo()?.userRoleID === USER_ROLES.BUNDLEDCLAIMUSER;
  }

  isDeliveryDefenseUser() {
    return this.getUserInfo()?.userRoleID === USER_ROLES.DDUSER;
  }

  isDDCommerceGuardUser() {
    const userInfo = this.getUserInfo();
    let policyDetails = null;

    try {
      const stored = sessionStorage.getItem('policyDetails');
      policyDetails = stored ? JSON.parse(stored) : null;
    } catch (e) {
      policyDetails = null;
    }

    return (
      userInfo?.userRoleID === USER_ROLES.DDCGUSER ||
      policyDetails?.commerceGuardIndicator === true
    );
  }

  isDDBillingFlow() {
    return sessionStorage.getItem('DDFlow') == 'billing';
  }

  isDDClaimsFlow() {
    return sessionStorage.getItem('DDFlow') == 'claims';
  }

  isDDClaimsFileFlow() {
    return sessionStorage.getItem('DDFlow') == 'claims/new';
  }

  isTupssUser() {
    return this.getUserInfo()?.userRoleID === USER_ROLES.TUPSSUSER;
  }

  isUserAdjuster() {
    return this.getUserInfo()?.userRoleID === USER_ROLES.ADJUSTER;
  }

  isAdminRole() {
    let userinfo = this.getUserInfo();
    if (userinfo.internalUser) {
      if (userinfo.app_role_id == 1) {
        return true;
      } else {
        return false;
      }
    } else {
      if (userinfo.userAppRoleID == 1) {
        return true;
      } else {
        return false;
      }
    }
  }

  // For now, we can base it off if they have access to billing content. Ideally, only admin and account managers can see DW material.
  canAccessDigitalWallet() {
    return this.getUserPermissions().isBillingPayments;
  }

  //Digital Wallet T+Cs will be open to all user roles, except claim viewer.
  canAccessDigitalWalletTCs() {
    //if user is administrator, billing manager, account manager, claims manager, or claims filer, let them go to Terms and Conditions
    if (this.hasAdministratorRole() || this.hasBillingManagerRole() || this.hasAccountManagerRole() || this.hasClaimsManagerRole() || this.hasClaimsFilerRole()) {
      return true;
    } else {
      return false;
    }
  }

  getshopifyUserObjectUID() {
    if (this.isShopifyUser()) {
      return this.getUserInfo().objectUID;
    }
    else {
      return null
    }
  }
  isCanadaUser() {
    let locale = sessionStorage.getItem('locale');
    if (locale == 'en-CA') {
      return true;
    } else {
      return false;
    }
  }
  isUsaUser() {
    let locale = sessionStorage.getItem('locale');
    if (locale == 'en') {
      return true;
    } else {
      return false;
    }
  }
  isUkUser() {
    let locale = sessionStorage.getItem('locale');
    if (locale == 'en-GB') {
      return true;
    } else {
      return false;
    }
  }
  isGermanyUser() {
    let locale = sessionStorage.getItem('locale');
    if (locale == 'en-DE' || locale == 'de-DE') {
      return true;
    } else {
      return false;
    }
  }
  isFranceUser() {
    let locale = sessionStorage.getItem('locale');
    if (locale == 'en-FR' || locale == 'fr-FR') {
      return true;
    } else {
      return false;
    }
  }
  isItalyUser() {
    let locale = sessionStorage.getItem('locale');
    if (locale == 'en-IT' || locale == 'it-IT') {
      return true;
    } else {
      return false;
    }
  }

  isInternalUser() {
    return this.getUserInfo()?.internalUser == true && this.getUserInfo()?.userRoleID != "2"; //excludes adjusters
  }

  isInternalAdminUser() {
    return this.getUserInfo()?.internalUser == true && this.getUserInfo()?.app_role_id == 1; //internal admin users
  }

  isCustomerAdminUser() {
    return this.getUserInfo()?.userRoleID == '1' && this.getUserInfo()?.userAppRoleID == '1'; //regular customer admin users
  }

  isWalletUser() {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    return dwDetails?.walletID ? true : false;
  }

  isWalletTCsAccepted() {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    return dwDetails?.tcAcceptance == '1' ? true : false;
  }

  isWalletRewardEligible() {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    return dwDetails?.rewardEligible?.toLowerCase() == 'true' ? true : false;
  }

  isWalletCashEligible() {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    return dwDetails?.cashEligible?.toLowerCase() == 'true' ? true : false;
  }

  //This is dependent on DW info. User must have a DW basically.
  isUPSBilled() {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    let billingType = dwDetails?.billingType?.trim()?.toLowerCase();
    if (billingType && billingType == "ups") {
      return true;
    } else {
      return false;
    }

    // if (this.isWalletCashEligible() && !this.isWalletRewardEligible()) {
    //   return true;
    // } else {
    //   return false;
    // }
  }

  //This is dependent on DW info. User must have a DW basically.
  isUPSCBilled() {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    let billingType = dwDetails?.billingType?.trim()?.toLowerCase();
    if (billingType && billingType == "upsc") {
      return true;
    } else {
      return false;
    }
    // if (this.isWalletCashEligible() && this.isWalletRewardEligible()) {
    //   return true;
    // } else {
    //   return false;
    // }
  }

  isUSPSUser() { // Tupss flex USPS policies check
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    if (policyDetails?.policyType?.key?.toUpperCase() == 'FLEX' && policyDetails?.policySource?.toUpperCase() == 'ISHIPFLEXMC') {
      return true;
    } else { return false; }
  }

  getCheckFeeAmount() {
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    return policyDetails?.checkProcessingFee && Number(policyDetails?.checkProcessingFee) ? Number(policyDetails.checkProcessingFee) : 0;
  }

  isIS4UAcquisitionUser() {
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    // User must have a quote for IS4UPS conversion in sessionStorage, and they must not have TC coverage already

    // if (conversionInfo && conversionInfo?.newRate && !policyDetails?.hasTCCoverage && this.getUserPermissions()?.isPolicyUpdate) {
    if (this.getUserPermissions()?.isPolicyUpdate && !policyDetails?.hasTCCoverage && policyDetails.subPolicyType == 'For UPS Packages') {
      return true;
    } else {
      return false;
    }
  }

  // deniedPartyCheck(partyInfo: PartyInfo) { //Unused
  //   let request = {
  //     'Party': {
  //       'ScreenType': 'Party',
  //       'CompanyName': partyInfo.company,
  //       /*'Address': {
  //           'AddressLine': partyInfo.address,
  //           'City': partyInfo.city,
  //           'State': partyInfo.state,
  //           'Zip': partyInfo.zip
  //       } */
  //       'Address': {
  //         'Country': 'United States of America'
  //       }
  //     }
  //   }
  //   return this.http.post<DeniedPartyResponse>(`${ENV.baseUrl.api}${API.CHECK_DENIED_PARTY}`, request, this.options).pipe(
  //     retry(3),
  //     map(result => {
  //       if (result.deniedPartyScreenerResponse.response.deniedPartySearchStatus === 'Denied Parties Found') {
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     })
  //   );
  // }

  deniedPartyCheckV2(data: DeniedPartyRequestData) {
    let request = {
      'party': {
        'address': {
          'city': data.city,
          'countryCode': data.country,
          'postalCode': data.zip,
          'state': data.state,
          'street': data.address
        },
        'companyName': data.company
      }
    }

    return this.http.post<DeniedPartyResponseV2>(`${ENV.baseUrl.api}${API.CHECK_DENIED_PARTY_V2}`, request, this.options).pipe(
      retry(3),
      map(result => {
        if (result && result.result == 'YES') {   //Denied party found
          return true;
        } else {  //No denied party found
          return false;
        }
      })
    );
  }

  policyCenterSearch(policy: string): Observable<any> {
    let shopifyUID = this.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      return this.http.get<any>(`${ENV.baseUrl.api}${API.POLICY_CENTER_SEARCH}/${policy}` + "?" + "objectUID=" + shopifyUID);
    }
    else {
      return this.http.get<any>(`${ENV.baseUrl.api}${API.POLICY_CENTER_SEARCH}/${policy}`);
    }
  }

  dataBricksPolicySearch(policy: string): Observable<any> {
    return this.http.get<any>(`${ENV.baseUrl.api}${API.DataBricks_POLICY_SEARCH}` + "?" + "policyNumber=" + policy);
  }

  isValidGuestUser(guestUserToken: string) {
    return this.loginService.getGuestAccessToken(guestUserToken).pipe(
      tap(data => {
        if (data.isValid == 'T') {
          sessionStorage.setItem('guestData', JSON.stringify(data));
          sessionStorage.setItem('isValidGuestUser', JSON.stringify(data.isValid));
          return true;
        }
        else {
          return false;
        }
      }),
      catchError(err => {
        throw err;
      })
    )
  }

  //For guest users
  loginForGuestUserNEW(landingUrl: string, pirateShipUser?: boolean) {
    let errorUrl = 'login';
    //We have policy number and an access token right now. The access token is an application token. "Anonymous" token
      this.setUserPermissions(['ClaimFile', 'PolicyView', 'HVCM']); //Hardcode permissions for the normal guest user permissions
    this.getPolicySearch(sessionStorage.getItem('policyNumber')).subscribe(
      policydata => {
        if (policydata?.data && policydata?.message?.toLowerCase() == 'succeeded') {
          sessionStorage.setItem('policyDetails', JSON.stringify(policydata.data));
          //Set User Details, similar to how internal user sets them.
          let userDetails = {
            active: true,
            approved: true,
            contactName: '',
            emailAddress: sessionStorage.getItem('guestUserEmail'),
            firstName: '',
            lastName: '',
            permissions: ['ClaimFile', 'PolicyView', 'HVCM'],
            policyHoldersName: '',
            userId: sessionStorage.getItem('userid'),
            userRoleID: pirateShipUser ? '1' : '3',  //UserInfo table role ID / HP OD users are 4
            app_role_id: pirateShipUser ? '3' : '4', //role id in relation to permissions 1 is Admin for HP OD / 
            internalUser: false,
            userPreference: {
              userPreferenceID: '',
              preferenceName: '',
              productCategory: '',
              carrier: '',
              address: {
                addressID: '',
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                city: '',
                state: '',
                zip: '',
                country: ''
              }
            },
            smbIndicator: false
          }
          sessionStorage.setItem('userDetails', JSON.stringify(userDetails));

          this.scriptService.pendoInit();
          this.router.navigateByUrl(landingUrl);
        } else {
          this.router.navigateByUrl(errorUrl);
        }
      }, error => {
        this.router.navigateByUrl(errorUrl);
      }
    );
  }

  getAutoAuthProfile(UID: string) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.AUTO_AUTH_PROFILE}`, { UID: UID });
  }

  //Should theoretically only be called once, and then stored in sessionStorage.getItem('policyDetails')
  public getPolicySearch(policyNumber: string) {
    const endpoint = `${environment.baseUrl.api}${ApiEndpoints.getPolicyDetails}`;
    let shopifyUID = this.getshopifyUserObjectUID();
    return this.http.get<any>(endpoint + `?policyNumber=${policyNumber}` + (shopifyUID !== null ? `&objectUID=${shopifyUID}` : ``),
      this.httpOptions).pipe(
        tap(data => data ? this.setLocale(data?.data?.policyCountry_Ext) : null)
      );
  }

  public getPermissions(appRoleId: number, policyNumber: string) {
    return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.getPermissions}?appRoleId=${appRoleId}&policyNumber=${policyNumber}`);
  }

  hasHVCM() {
    return JSON.parse(sessionStorage.getItem('policyDetails'))?.hvcm == true;
  }

  get isHVCMFlow() {
    return this._isHVCMFlow
  }

  set isHVCMFlow(hvcm) {
    this._isHVCMFlow = hvcm;
  }

  getHVCMUrl(request) {
    return this.http.post<{ data: { url: string } }>(`${ENV.baseUrl.api}${API.HVCM}`, request);
  }

  openHVCM(payload: any) {
    this.getHVCMUrl(payload).subscribe(
      res => {
        if(res.data.url.indexOf('?id=') > 0) {
            sessionStorage.setItem('HVCMSession', JSON.stringify(
              { ...payload, terminateSession: res.data.url.split('?id=')[1] }
            ));
        }
        if (res?.data.url != '') {
          window.open(res.data.url);
        }
        else {
          window.open(ENV.hvcm.url);
        }
      },
      error => window.open(ENV.hvcm.url)
    );
  }

  //Used only in 2 places. App component (For initial app load & page refreshing) and login (policy search country code to update locale if necessary)
  //BehaviorSubject variable makes sure that all components react immediately if locale is updated (Particularly useful when user logs in with a different policy locale)
  //sessionStorage variable is needed because BehaviorSubject gets lost on page refresh
  setLocale(countryCode) {
    let currentLanguage = this.translateService.currentLang;
    //currentLanguage is mainly used to compare the locale they may have had during the login screens to the locale of the policy.
    //Particularly useful when keeping, for example, fr-fr locale, so that it doesn't always turn into en-FR
    if (currentLanguage) {
      if (countryCode == 'CA' || countryCode == 'en-CA') {
        this.locale.next('en-CA');
        sessionStorage.setItem('locale', 'en-CA');
      }
      else if (countryCode == 'US' || countryCode == 'en') {
        this.locale.next('en');
        sessionStorage.setItem('locale', 'en');
      }
      else if (countryCode == 'GB' || countryCode == 'en-GB') {
        this.locale.next('en-GB');  // United Kingdom
        sessionStorage.setItem('locale', 'en-GB');
      }
      else if (countryCode == 'DE' || countryCode?.includes('DE')) {
        if (currentLanguage == 'de-DE') {
          this.locale.next('de-DE');
          sessionStorage.setItem('locale', 'de-DE');
        } else {
          this.locale.next('en-DE'); // Germany
          sessionStorage.setItem('locale', 'en-DE');
        }
      }
      else if (countryCode == 'FR' || countryCode?.includes('FR')) {
        if (currentLanguage == 'fr-FR') {
          this.locale.next('fr-FR');
          sessionStorage.setItem('locale', 'fr-FR');
        } else {
          this.locale.next('en-FR'); // France
          sessionStorage.setItem('locale', 'en-FR');
        }
      }
      else if (countryCode == 'IT' || countryCode?.includes('IT')) {
        if (currentLanguage == 'it-IT') {
          this.locale.next('it-IT');
          sessionStorage.setItem('locale', 'it-IT');
        } else {
          this.locale.next('en-IT'); // Italy
          sessionStorage.setItem('locale', 'en-IT');
        }
      }
    }
    else {
      let locales = sessionStorage.getItem('locale');
      this.locale.next(locales);
    }
    this.getLocale().subscribe(data => { sessionStorage.setItem('locale', data); })
  }

  //Will always be in the form language-COUNTRYCODE, unless default, which is just 'en'
  //example - en-CA
  getLocale() {
    return this.locale;
  }

  getUserIDs(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.GET_USER_IDS_FOR_POLICY}`, request);
  }

  getUserInfoListForPolicy(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.GET_USER_INFO_LIST_FOR_POLICY}`, request);
  }

  updateUser(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.adminUpdateUser}`, request);
  }

  inviteUser(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.inviteUser}`, request);
  }

  deleteUser(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.adminDeleteUser}`, request);
  }

  deleteInvitedUser(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.deleteInvitedUser}`, request);
  }

  validateIDToken(idToken: any) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.RLS_Auto_Authentication}`, { token: idToken });
  }

  // public getUsers(id: string) {//Unused API
  //   const endpoint = `${environment.baseUrl.api}${ApiEndpoints.getUserById}`;
  //   return this.http.get<any>(endpoint + `/${id}`, this.httpOptions);
  // }


  // public getUsersByUserId(id: string) {
  //   const endpoint = `${environment.baseUrl.api}${ApiEndpoints.GET_USERS_BY_USERID}`;
  //   return this.http.get<any>(endpoint + `/${id}`, this.httpOptions);
  // }

  getUserAdminCount(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.adminUserCount}`, request);
  }

  // updateUserDetails(request) {//Unused
  //   return this.http.post<any>(`${ENV.baseUrl.api}${API.UPDATE_USER_DETAILS}`, request);
  // }

  decryptParams(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.DESCRPT_PARAMS}`, request);
  }

  decryptPirateShipTrackingNumber(request: { token: string }) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.PIRATE_SHIP_DECRYPT_TRACKING_NUMBER}`, request);
  }

  getTokens(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.GET_ACCESS_TOKEN}`, request);
  }

  getMCInfo(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.GET_MC_INFO}`, request);
  }


 hasAdministratorRole() {
  return this.userInfo?.userRole?.toLowerCase() === ONL_USER_ROLES.ADMINISTRATOR;
 }

  hasBillingManagerRole() {
    if (this.userInfo.userRole?.toLowerCase() == ONL_USER_ROLES.BILLING_MANAGER) {
      return true;
    } else {
      return false;
    }
  }

  hasAccountManagerRole() {
    if (this.userInfo.userRole?.toLowerCase() == ONL_USER_ROLES.ACCOUNT_MANAGER) {
      return true;
    } else {
      return false;
    }
  }

  hasClaimsManagerRole() {
    if (this.userInfo.userRole?.toLowerCase() == ONL_USER_ROLES.CLAIMS_MANAGER) {
      return true;
    } else {
      return false;
    }
  }

  hasClaimsFilerRole() {
    if (this.userInfo.userRole?.toLowerCase() == ONL_USER_ROLES.CLAIMS_FILER) {
      return true;
    } else {
      return false;
    }
  }

  getVerificationCode(request): Observable<any> {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.GET_VERIFICATION_CODE}`, request);
  }

  getConsumerElectedInsurance(): Observable<any> {
    return this.http.post(`${ENV.baseUrl.api}${API.consumerElectedInsurance}`, '', {
      responseType: 'text' as 'json'
    });
  }

  createUser(request) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.CREATE_USER}`, request);
  }

}
